import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import type { FC, ReactNode } from "react";

import * as Styled from "./GetUpdatesDialog.styles";

interface IGetUpdatesDialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const GetUpdatesDialog: FC<IGetUpdatesDialogProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <Styled.Root open={open} onClose={onClose}>
      <Styled.CloseButton aria-label="Close" size="small" onClick={onClose}>
        <CloseRoundedIcon />
      </Styled.CloseButton>
      {children}
    </Styled.Root>
  );
};
